<template>
    <b-card :header="caption">
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
            <template slot="type" slot-scope="data">
                <b-badge :variant="getBadge(data.item.type)">{{data.item.type}}</b-badge>
            </template>
            <template slot="status" slot-scope="data">
                <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
            </template>
        </b-table>
        <nav>
            <b-pagination size="sm" :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
        </nav>
    </b-card>
</template>

<script>

    import {gtableConfig} from "../../config/gtable-config"

    export default {
        name: "g-table",
        props: {
            caption: {
                type: String,
                default: ''
            },
            baseUrl: {
                type: String,
                default: '',
            },
            trailingUrl: {
                type: String,
                default: '',
            },
            hover: {
                type: Boolean,
                default: true
            },
            striped: {
                type: Boolean,
                default: true
            },
            bordered: {
                type: Boolean,
                default: false
            },
            small: {
                type: Boolean,
                default: false
            },
            fixed: {
                type: Boolean,
                default: false
            },
            items: {
                type: Array,
                default: [],
            },
            fields: {
                type: Array,
                default: [
                    {key: 'id'},
                    {key: 'name'},
                    {key: 'type'},
                    {key: 'status'}
                ],
            }

        },
        data: () => {
            return {
                currentPage: 1,
                perPage: 5,
                totalRows: 0
            }
        },
        methods: {
            getBadge (value) {
                if (gtableConfig.success.includes(value)) {
                    return 'success'
                }

                if (gtableConfig.danger.includes(value)) {
                    return 'danger'
                }

                if (gtableConfig.dark.includes(value)) {
                    return 'dark'
                }

                if (gtableConfig.primary.includes(value)) {
                    return 'primary'
                }

                return 'secondary'
            },
            getRowCount (items) {
                return items.length
            },
            listingLink (id) {
                return `${this.baseUrl}/${id.toString()}${this.trailingUrl}`
            },
            rowClicked (item) {
                const link = this.listingLink(item.id)
                this.$router.push({path: link})
            }

        }
    }
</script>